import React, { useState, useEffect, useContext, useRef } from 'react'
import imgProfile from '../assets/image/header-image.png' // with import
import SurvayModal from '../modals/SurveyModal'
import RulesModal from '../modals/RulesModal'
import NumberFormat from 'react-number-format'
import { useHistory } from 'react-router-dom'
import BazaarLogo from '../assets/image/bazaar.png'
import TripContext from '../contexts/TripContext'
import PDFViewerModal from '../modals/PDFViewerModal'
import TripReceipt from '../components/TripReceipt'
import Axios from 'axios'
import endpoints from '../js/endpoints'
import StringHelper from '../helper/StringHelper'
import { Route, Switch, useLocation } from 'react-router-dom'
import { Navbar, Nav, Spinner } from 'react-bootstrap'
import pagePath from '../pagePath'

export default function TripInfo(props) {
  // let location = useLocation()
  // var search = new URLSearchParams(location.search)
  // const searchPath = location.pathname.substring(1)

  var search = props.match.params.id;
  const history = useHistory()
  const [loading, setIsLoading] = useState(true)
  const [trip, setTrip] = useState({})

  useEffect(() => {

    setTrip({
      serviceCode: search,
    })

    setTimeout(() => {
      getTripInfo()
    }, 300)
    // console.log('ssssssssssssssssssssss',search,props.match.params.id)

  }, [])


  const [showSurvay, setShowSurvay] = useState()
  const [showRules, setShowRules] = useState()
  // const [rateAvalable, setRateAvalable] = useState(false)
  const [showPDFViewerFlag, setShowPDFViewerFlag] = useState(false)

  const showSurvayModal = () => {
    setShowSurvay(true)
  }

  const closeSurvayModal = () => {
    setShowSurvay(false)
    // setRateAvalable(true)
  }

  const showRulesModal = () => {
    setShowRules(true)
    //  window.open(tripContext.trip.rulesUrl, '_blank',"width=400, height=300")

  }
  const closeRulesModal = () => {
    setShowRules(false)
  }

  const goToBazaar = () => {
    window.open(trip.cafebazaarLink, '_blank')
  }

  const goToCorporate = () => {
    window.open(trip.corporateLink, '_blank')
  }
  const downloadDirectApp = () => {
    window.open(trip.customerAppLink, '_blank')
  }

  const goToBeDriver = () => {
    window.open(trip.driverRegisterLink, '_blank')
  }

  const showReceiptPDFViewer = () => {
    setShowPDFViewerFlag(true)
  }

  const closeReceiptPDFViewer = () => {
    setShowPDFViewerFlag(false)
  }


  let goDriverLocation = () => {
    history.replace(pagePath.driver_location + search)
  }


  let getTripInfo = () => {
    setIsLoading(true)

    Axios({
      url: endpoints.GetTripInfo,
      method: 'get',
      params: { refNum: search },
    })
      .then((res) => {
        console.log('aaaaaaaaaaaaaaaa', res.data)
        setTrip({
          serviceCode: search,
          tripCode: res.data.result?.serviceCode,
          driverName: res.data.result?.driverName,
          taxicode: res.data.result?.taxicode,
          driverMob: res.data.result?.driverMob,
          addr: res.data.result?.addr,
          destination1: res.data.result?.destination1,
          destination2: res.data.result?.destination2,
          price: res.data.result?.price,
          priceInt: res.data.result?.mabser ? res.data.result?.mabser : 0,
          finished: res.data.result?.finished,
          natCode: res.data.result?.natCode,
          cartype: res.data.result?.cartype,
          blackDesc: res.data.result?.blackDesc,
          redDesc: res.data.result?.redDesc,
          greenDesc: res.data.result?.greenDesc,
          color: res.data.result?.color,
          plak: res.data.result?.plak,
          DriverScore: res.data.result?.DriverScore,
          descTript: res.data.result?.descTript,
          exitTime: res.data.result?.exitTime,
          enterTime: res.data.result?.enterTime,
          passengerName: res.data.result?.passengerName,
          headerFactor: res.data.result?.headerFactor,
          descFactor: res.data.result?.descFactor,
          addrFactor: res.data.result?.addrFactor,
          paymentUrl: res.data.result?.paymentUrl,

          telFactor: res.data.result?.telFactor,
          distance: res.data.result?.distance,
          stopTime: res.data.result?.stopTime,
          serviceDate: res.data.result?.serviceDate,
          videoUrl: res.data.result?.videoUrl,
          cafebazaarLink: res.data.result?.customerAppLink,
          customerAppLink: res.data.result?.customerDirectAppLink,
          driverRegisterLink: res.data.result?.driverRegisterLink,
          survetPanelHeader: res.data.result?.survetPanelHeader,
          feedbackText: res.data.result?.feedbackText,
          picUrl: res.data.result?.picUrl,
          rulesUrl: res.data.result?.rulesUrl,
          path: res.data.result?.path,
          duration: res.data.result?.duration,
          startDate: res.data.result?.startDate,
          startTime: res.data.result?.startTime,
          endDate: res.data.result?.endDate,
          corporateLink: res.data.result?.corporateLink,
          endTime: res.data.result?.endTime,
          distance: res.data.result?.distance,
          showDriverLocation: res.data.result?.showDriverLocation == 1 ? true : false,
          showSignupDriver: res.data.result?.showSignupDriver == 1 ? true : false,
          showTripDistance: res.data.result?.showTripDistance == 1 ? true : false
        })
        setIsLoading(false)


      })
      .catch(function (error) {
        console.log(error)
      })
  }

  // var MediaSource = useRef()
  // MediaSource.current.muted = true

  return (


    <>
      {loading ? (
        <p2>
          <Spinner animation="border" className="m-5" />
        </p2>
      ) : (<TripContext.Provider value={{ trip }}>


        <div className="d-flex flex-column align-items-center container col-12 col-sm-12 col-md-12 col-lg-8 ">


          <div className="row  p-2  col-12">
            <div className="col-12 col-md-4  col-lg-4 col-xl-4 col-sm-12   d-flex flex-column">

              {trip.videoUrl !== "" ?

                // <iframe
                //   src="
                //   "
                //   frameborder="0"
                //   scrolling="no"
                //   allowfullscreen="true"
                //   mozallowfullscreen="true"
                //   webkitallowfullscreen="true"></iframe>

                <iframe
                  src={`https://www.aparat.com/video/video/embed/videohash/${trip.videoUrl}/vt/frame?autoplay=true&360d=true`}
                  autoplay="true"
                  allowFullScreen="true"
                  webkitallowfullscreen="true"
                  mozallowfullscreen="true"
                  frameborder="0"
                  allow="autoplay"
                  sound='off'                >
                </iframe>
                :
                null
              }





              {trip.picUrl ?
                <img
                  className="rounded-circle mx-auto d-block mt-2 mb-2"
                  src={trip.picUrl}
                  width="150"
                  height="150"
                  alt="تصویر راننده"
                />
                :
                <></>
              }
              <div>

                <div className="d-flex row m-0">





                  {
                    trip?.showDriverLocation ?
                      <div className="col-6 d-flex p-1">
                        <button
                          type="button"
                          className="btn btn-outline-primary col-12 overflow-auto d-inline-block text-truncate"
                          onClick={goDriverLocation}
                        >
                          موقعیت راننده

                        </button>
                      </div>
                      :
                      <></>
                  }


                  <div className="col-6 d-flex  p-1">
                    <button
                      type="button"
                      className="btn btn-outline-primary col-12 overflow-auto d-inline-block text-truncate "
                      onClick={showSurvayModal}
                      disabled={trip.finished === 0}
                    >
                      نظرسنجی
                    </button>
                  </div>
                  <div className="col-6 d-flex  p-1">

                    <button
                      type="button"
                      className="btn btn-outline-primary  col-12 overflow-auto d-inline-block text-truncate"
                      onClick={showReceiptPDFViewer}
                    >
                      رسید سفر
                    </button>
                  </div>
                  <div className="col-6 d-flex p-1">
                    <button
                      type="button"
                      className="btn btn-outline-primary col-12 "
                      onClick={showRulesModal}
                    >
                      قوانین
                    </button>
                  </div>

                  {trip.showSignupDriver ?
                    <div className="col-6 d-flex  p-1">
                      <button
                        type="button"
                        className="btn btn-outline-primary text overflow-auto col-12 "
                        onClick={goToBeDriver}>

                        ثبت نام راننده

                      </button>
                    </div>
                    : <></>}

                  {console.log('gggggggggggg',(trip?.paymentUrl != '' && trip?.paymentUrl)?'1':"2")}
                  {(trip?.paymentUrl != '' && trip?.paymentUrl) ?
                    <div className="col-6 d-flex  p-1">

                      <a
                        href={trip.paymentUrl}
                        className="btn btn-outline-primary text overflow-auto col-12 "
                      >

                        پرداخت هزینه سفر

                      </a>
                    </div>
                    : <></>}
                  <div className="col-6 d-flex  p-1">

                    {trip.cafebazaarLink ?
                      <button
                        type="button"
                        className="btn btn-outline-success  col-12"
                        onClick={goToBazaar}
                      >
                        <img src={BazaarLogo} width="40" height="25" className="mr-1" />
                      </button>
                      :
                      null
                    }
                  </div>

                  {trip.corporateLink ?
                    <div className="col-6 d-flex  p-1">
                      <button
                        type="button"
                        className="btn btn-outline-primary text overflow-auto col-12 "
                        onClick={goToCorporate}>

                        پنل سازمانی

                      </button>
                    </div>
                    : <></>}

                </div>


                <div className='d-flex row m-0'>

                  <div className="col-12 d-flex  p-1">

                    {trip.customerAppLink ?
                      <button
                        type="button"
                        className="btn btn-success col-12 overflow-auto d-inline-block text-truncate"
                        onClick={downloadDirectApp}
                      >
                        دریافت مستقیم اپ مشتری
                      </button>

                      :
                      null
                    }
                  </div>
                </div>

              </div>


            </div>
            <div className="col-12 col-md-8  col-lg-8 col-xl-8 col-sm-12   mt-2">
              <div className="d-flex flex-column font-weight-bold text-right card w-100">
                <h5 className="card-header ">مشخصات راننده</h5>

                <div className="card-body">
                  <div>
                    <label className="col-md-4 col-6 title">نام:</label>
                    <label className="col-md-8 col-6 content">
                      {trip.driverName}
                    </label>
                  </div>
                  <div>
                    <label className="col-md-4 col-6 title">کد:</label>
                    <label className="col-md-8 col-6 content">
                      {trip.taxicode}
                    </label>
                  </div>
                  <div>
                    <label className="col-md-4 col-6 title">تماس با راننده:</label>
                    <label className="col-md-8 col-6 content">
                      <a href={`tel:${trip.driverMob}`}>{trip.driverMob}</a>
                    </label>

                  </div>
                  <div>
                    <label className="col-md-4 col-6 title">خودرو:</label>
                    <label className="col-md-8 col-6 content">
                      {trip.cartype + ' ' + trip.color}
                    </label>
                  </div>
                  <div>
                    <label className="col-md-4 col-6 title">پلاک:</label>
                    <label className="col-md-8 col-6 content">
                      {trip.plak}
                    </label>
                  </div>

                </div>
              </div>
              <div className="d-flex flex-column font-weight-bold text-right card w-100 mt-2">
                <h5 className="card-header">مشخصات سفر</h5>

                <div className="card-body">
                  <div>
                    <label className="col-md-4 col-6 title"> تاریخ: </label>
                    <label className="col-md-8 col-6 content">
                      {trip.serviceDate}
                    </label>
                  </div>
                  <div>
                    <label className="col-md-4 col-6 title"> مدت زمان سفر: </label>
                    <label className="col-md-8 col-6 content">
                      {trip.duration} دقیقه
                    </label>
                  </div>
                  {
                    trip.showTripDistance ?
                      <div>
                        <label className="col-md-4 col-6 title">مسافت طی شده:</label>
                        <label className="col-md-8 col-6 content">
                          {(trip.distance / 1000).toFixed()} کیلومتر
                        </label>
                      </div>
                      : <></>
                  }

                  <div>
                    <label className="col-md-4 col-sm-12 title"> مبدا : </label>
                    <label className="col-md-8 col-sm-12 content">
                      {trip.addr}
                    </label>
                  </div>
                  <div>
                    <label className="col-md-6 col-12 col-lg-4 title">مقصد :</label>
                    <label className="col-md-6 col-12 col-lg-8 content">
                      {trip.destination1}
                    </label>
                  </div>
                  {trip.destination2 !== '' ? (
                    <div>
                      <label className="col-md-6 col-12 col-lg-4 title">
                        مقصد دوم :
                      </label>
                      <label className="col-md-6 col-12 col-lg-8 content">
                        {trip.destination2}
                      </label>
                    </div>
                  ) : null}
                  <div>
                    <label className="col-md-4 col-sm-12   title">هزینه:</label>
                    <label
                      className="col-md-8 col-sm-12 "
                      style={{ color: '#f0f' }}
                    >
                      <NumberFormat
                        value={trip.price}
                        displayType={'text'}
                        thousandSeparator={true}
                        className="mx-1"
                      />
                      تومان
                    </label>
                  </div>
                  <div className="col-12">
                    <div className="col-12 col-lg-6"></div>
                  </div>
                </div>
                {/* <div className="d-flex justify-content-cneter px-1 my-2 w-100">
              <Link
                className="btn btn-success col-12 col-md-5 col-lg-4"
                to={{ pathname: pagePath.map }}
              >
                مشاهده مسیر سفر
              </Link>
            </div> */}
              </div>
              <p className='text-justify '>
                {trip?.blackDesc}
              </p>
              <p className='text-justify text-danger font-weight-bold '>
                {trip?.redDesc}
              </p>
              <p className='text-justify text-danger font-weight-bold '>
                {trip?.greenDesc}
              </p>
            </div>
          </div>
          {showSurvay ? (
            <SurvayModal show={showSurvay} onChange={closeSurvayModal} />
          ) : null}
          {showRules ? (
            <RulesModal show={showRules} onChange={closeRulesModal} />
          ) : null}

          {showPDFViewerFlag ?
            <PDFViewerModal
              show={showPDFViewerFlag}
              onChange={closeReceiptPDFViewer}
              title="رسید سفر"
              actionTitle="چاپ" >
              <TripReceipt item={trip} />
            </PDFViewerModal>
            : null}
        </div>
      </TripContext.Provider>
      )
      }


    </>
  )
}
